module.exports = __webpack_public_path__ + "static/media/img-11.921c84c9.jpg";